import FJMyCreations from './FJMyCreations';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import useLocalStore from '../../../../../hooks/useLocalStore';
import { useEffect, useCallback } from 'react';
import FJActionCommunity from '../../../../../redux/action/FJActionCommunity';
import FJConstant from '../../../../../constants/FJConstant';
const FJMyCreationsContainer = props => {
    const { active } = props;
    const dispatch = useDispatch();
    const myCreationsList = useSelector(state => state.community.myCreationsList);
    const myCreationsPageLoading = useSelector(state => state.community.myCreationsPageLoading);
    useLocalStore();
    useEffect(() => {
        dispatch(FJActionCommunity.initMyCreationsListAction());
    }, [dispatch]);
    const seeAll = useCallback(
        collection => {
            dispatch(FJActionCommunity.getMyCreationsDetailListAction(collection));
        },
        [dispatch],
    );

    const changeNavBarToAIList = useCallback(() => {
        dispatch(FJActionCommunity.changeNavBarTabAction(FJConstant.AI_TOOL_LIST));
    }, [dispatch]);
    if (!active) return null;
    return (
        <FJMyCreations
            active={active}
            myCreationsList={myCreationsList}
            seeAll={seeAll}
            myCreationsPageLoading={myCreationsPageLoading}
            changeNavBarToAIList={changeNavBarToAIList}
        />
    );
};

FJMyCreationsContainer.propTypes = {
    active: PropTypes.bool.isRequired,
};

export default FJMyCreationsContainer;
